import React from 'react';
import { MailIcon, MessageCircleIcon } from 'lucide-react';
export function Footer() {
  return <footer className="w-full border-t border-white/10 px-5 py-10" data-id="element-117" data-mp="208cbh1lax1nz">
      <div className="mx-auto max-w-4xl text-center" data-id="element-118" data-mp="2f4tm1qlo2c9h">
        <p className="font-display text-xl text-snow" data-id="element-119" data-mp="2f3ikzyjlvim2">Aula Baile Pro</p>
        <p className="mt-1 text-[10px] font-extrabold uppercase tracking-[0.2em] text-lime" data-id="element-120" data-mp="2a57639egehwz">
          Megapack Danza Clásica Pro
        </p>

        <nav className="mt-5 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-sm font-semibold text-snow-muted" data-id="element-121" data-mp="1mgfo1aukvfxx">
          <a href="#soporte" className="inline-flex items-center gap-1.5 transition-colors hover:text-lime" data-id="element-122" data-mp="1w5z5cc2n71qo">
            <MailIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-123" data-mp="1rfirwrytng4b" /> Soporte
          </a>
          <a href="#contacto" className="inline-flex items-center gap-1.5 transition-colors hover:text-lime" data-id="element-124" data-mp="13poi6j9su7oa">
            <MessageCircleIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-125" data-mp="yqtmwhunaqna" /> Contacto
          </a>
          <a href="#terminos" className="transition-colors hover:text-lime" data-id="element-126" data-mp="1eic06ym6m2mh">
            Términos y condiciones
          </a>
        </nav>

        <p className="mx-auto mt-6 max-w-2xl text-xs leading-relaxed text-snow-dim" data-id="element-127" data-mp="1iicqbgin829d">
          Material digital de uso personal para profesoras. Los resultados dependen de la
          aplicación de cada profesora. © {new Date().getFullYear()} Aula Baile Pro.
        </p>
      </div>
    </footer>;
}